import type { ConcurrencySequenceSpec } from '../model.js';

export function concurrencySequenceFixture(
  width = 640,
  stress = false,
  visibleThrough?: number,
  focusEventId?: string,
): ConcurrencySequenceSpec {
  const events: ConcurrencySequenceSpec['events'] = stress
    ? [
        { id: 'submit', from: 'request', to: 'channel', label: 'send reconciliation request', kind: 'call' },
        { id: 'handoff', from: 'channel', to: 'worker', label: 'handoff immutable work item', kind: 'return' },
        { id: 'blocked', from: 'request', to: 'request', label: 'blocked awaiting completion result', kind: 'wait' },
        { id: 'begin', from: 'worker', to: 'postgres', label: 'begin serializable transaction', kind: 'call' },
        { id: 'reserve', from: 'worker', to: 'postgres', label: 'conditionally reserve inventory units', kind: 'call' },
        { id: 'commit', from: 'postgres', to: 'worker', label: 'commit acknowledged with new version', kind: 'return' },
        { id: 'publish', from: 'worker', to: 'channel', label: 'publish successful reconciliation result', kind: 'return' },
        { id: 'resume', from: 'channel', to: 'request', label: 'resume blocked request goroutine', kind: 'return' },
      ]
    : [
        { id: 'submit', from: 'request', to: 'channel', label: 'send job', kind: 'call' },
        { id: 'handoff', from: 'channel', to: 'worker', label: 'receive job', kind: 'return' },
        { id: 'blocked', from: 'request', to: 'request', label: 'wait for result', kind: 'wait' },
        { id: 'update', from: 'worker', to: 'postgres', label: 'UPDATE stock', kind: 'call' },
        { id: 'commit', from: 'postgres', to: 'worker', label: 'commit OK', kind: 'return' },
        { id: 'resume', from: 'worker', to: 'request', label: 'result <- nil', kind: 'return' },
      ];

  return {
    id: stress ? 'concurrency-sequence-stress' : 'concurrency-sequence',
    family: 'concurrency-sequence',
    view: 'sequence',
    viewport: { width, height: stress ? 500 : 460 },
    participants: stress
      ? [
          { id: 'request', label: 'HTTP request goroutine #2471', role: 'actor' },
          { id: 'channel', label: 'unbuffered reconciliation channel', role: 'runtime' },
          { id: 'worker', label: 'inventory reservation worker', role: 'service' },
          { id: 'postgres', label: 'primary PostgreSQL connection', role: 'storage' },
        ]
      : [
          { id: 'request', label: 'request', role: 'actor' },
          { id: 'channel', label: 'jobs chan', role: 'runtime' },
          { id: 'worker', label: 'worker', role: 'service' },
          { id: 'postgres', label: 'Postgres', role: 'storage' },
        ],
    events,
    ...(visibleThrough === undefined ? {} : { visibleThrough }),
    ...(focusEventId === undefined ? {} : { focusEventId }),
    provenance: 'Go goroutine, channel, worker, and PostgreSQL trace · explicit logical ordering',
  };
}
